export default __webpack_public_path__ + "static/combination-of-different-series-types-ae1aa50c864d736de72192020d012cb7.png";